import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasUnifiedInstitutionSchema = withDefaults({
  type: 'tas-unified-institution',
  fields: [
    {
      kind: 'attribute',
      name: 'isFeatured',
    },
    {
      kind: 'attribute',
      name: 'isPreferred',
    },
    {
      kind: 'attribute',
      name: 'dapipId',
    },
    {
      kind: 'attribute',
      name: 'institutionId',
    },
    {
      kind: 'attribute',
      name: 'address',
    },
    {
      kind: 'attribute',
      name: 'locationName',
    },
    {
      kind: 'attribute',
      name: 'locationType',
    },
    {
      kind: 'attribute',
      name: 'lpn',
    },
  ],
});

export default TasUnifiedInstitutionSchema;
